/* Public cart properties are fulfillment notes, never trusted inventory authority. */
(function (root, factory) {
  const api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  else root.C701GiftBoxCore = api;
})(typeof window === 'undefined' ? globalThis : window, function () {
  'use strict';
  const PARENTS = Object.freeze({ '48463321530623': 2, '48468144718079': 3 });
  const isParent = id => Object.hasOwn(PARENTS, String(id));
  const fail = (code, message) => { const e = new Error(message); e.code = code; throw e; };
  function quantity(value, allowZero = false) {
    const n = Number(value);
    if (!Number.isSafeInteger(n) || n < (allowZero ? 0 : 1) || n > 99) fail('quantity', 'Choose a whole number of gift boxes from 1 to 99.');
    return n;
  }
  function catalogMap(rows) {
    const map = new Map();
    for (const row of rows || []) {
      const id = String(row.id);
      if (!/^\d+$/.test(id) || map.has(id)) fail('catalog', 'Refresh the page to check the available scents.');
      map.set(id, { ...row, id });
    }
    return map;
  }
  function choicesFor(parentId, choices, catalog, requireAvailable = true) {
    const count = PARENTS[String(parentId)];
    if (!count || !Array.isArray(choices) || choices.length !== count || choices.some(x => !x)) fail('choices', 'Choose a scent for every candle.');
    return choices.map(value => {
      const scent = catalog.get(String(value));
      if (!scent || scent.tracked !== true || scent.policy !== 'deny' || !Number.isSafeInteger(scent.quantity) || scent.quantity < 0) fail('ineligible', 'One of these scents is no longer available. Please choose again.');
      if (requireAvailable && (!scent.available || scent.quantity === 0)) fail('sold_out', `${scent.title} is currently unavailable. Please choose another scent.`);
      return scent;
    });
  }
  function propertiesFor(scents) {
    const properties = { _701_gift_box: 'v1', _701_candle_variant_ids: scents.map(x => x.id).join(',') };
    scents.forEach((scent, i) => { properties[`Candle ${i + 1} scent`] = scent.title; });
    return properties;
  }
  function lineChoices(item, catalog) {
    const properties = item.properties || {};
    const ids = typeof properties._701_candle_variant_ids === 'string' ? properties._701_candle_variant_ids.split(',') : [];
    const scents = choicesFor(item.variant_id, ids, catalog, false);
    const expected = propertiesFor(scents);
    if (Object.keys(expected).some(k => properties[k] !== expected[k])) fail('cart_choices', 'A gift box in your cart needs its scent choices checked. Remove it and choose the scents again.');
    return scents;
  }
  function cartDemand(cart, catalog) {
    const demand = new Map();
    const add = (id, q) => demand.set(id, (demand.get(id) || 0) + q);
    for (const item of cart.items || []) {
      const q = quantity(item.quantity, true);
      if (!q) continue;
      if (isParent(item.variant_id)) lineChoices(item, catalog).forEach(scent => add(scent.id, q));
      else if (catalog.has(String(item.variant_id))) add(String(item.variant_id), q);
    }
    return demand;
  }
  function assertStock(demand, catalog) {
    for (const [id, requested] of demand) {
      const scent = catalog.get(id);
      if (!scent || !scent.available || requested > scent.quantity) fail('stock', `There are not enough ${scent?.title || 'selected'} candles for the quantities in your cart. Choose another scent or reduce the quantity.`);
    }
  }
  function buildAdd({ parentId, quantity: value, choices, stock, cart }) {
    if (!isParent(parentId)) fail('parent', 'This gift box is not available.');
    const q = quantity(value), catalog = catalogMap(stock), scents = choicesFor(parentId, choices, catalog);
    const demand = cartDemand(cart, catalog);
    scents.forEach(scent => demand.set(scent.id, (demand.get(scent.id) || 0) + q));
    assertStock(demand, catalog);
    return { items: [{ id: Number(parentId), quantity: q, properties: propertiesFor(scents) }] };
  }
  function checkChange({ cart, key, quantity: value, stock }) {
    const q = quantity(value, true);
    const line = (cart.items || []).find(item => item.key === key);
    if (!line) fail('line', 'Your cart has changed. Refresh it before updating this gift box.');
    if (q === 0) return { id: key, quantity: 0 };
    const catalog = catalogMap(stock);
    const next = { ...cart, items: cart.items.map(item => item.key === key ? { ...item, quantity: q } : item) };
    assertStock(cartDemand(next, catalog), catalog);
    return { id: key, quantity: q };
  }
  function signature(id, properties) {
    return JSON.stringify([String(id), Object.entries(properties || {}).sort(([a], [b]) => a.localeCompare(b))]);
  }
  function totals(cart) {
    const result = new Map();
    for (const item of cart.items || []) {
      const key = signature(item.variant_id, item.properties);
      result.set(key, (result.get(key) || 0) + Number(item.quantity));
    }
    return result;
  }
  function reconcile(before, after, item) {
    const key = signature(item.id, item.properties), a = totals(before), b = totals(after);
    const delta = (b.get(key) || 0) - (a.get(key) || 0);
    const unrelatedChanged = [...new Set([...a.keys(), ...b.keys()])].some(k => k !== key && (a.get(k) || 0) !== (b.get(k) || 0));
    const lineKeys = (after.items || []).filter(x => signature(x.variant_id, x.properties) === key).map(x => x.key);
    if (!unrelatedChanged && delta === item.quantity) return { status: 'added', lineKeys };
    if (!unrelatedChanged && delta === 0) return { status: 'unchanged', lineKeys };
    return { status: 'review', lineKeys };
  }
  return { PARENTS, isParent, quantity, catalogMap, choicesFor, propertiesFor, cartDemand, buildAdd, checkChange, reconcile };
});
